import useSweetAlert from '../hooks/useSweetAlert';

export const setAlert = (msg, alertType, timeout = 5000) => async dispatch => {
    const { showToast } = useSweetAlert();
	await showToast(msg, alertType);
	return;
}